import { get } from "../../../Services/http";
import { catchError } from "../../../Actions/Error.action";

export const VIDEO_BLOCK_RECEIVE = "VIDEO_BLOCK_RECEIVE";
export const VIDEO_BLOCK_ERROR = 'VIDEO_BLOCK_ERROR';

export const fetchVideoModel = (id) => (dispatch) => {
    return get('/api/videoblock/' + id)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const receive = result => ({
    type: VIDEO_BLOCK_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: VIDEO_BLOCK_ERROR,
    payload: {
        error,
    },
})